import { Entity } from '@ebeihilfe/core';

export class AntragLimit extends Entity<AntragLimitProps> {
  public get antraegeLeftToday(): number {
    return this.getProps().antraegeLeftToday;
  }

  public get isLimited(): boolean {
    return this.getProps().isLimited;
  }

  public get limit(): number {
    return this.getProps().limit;
  }
}

export interface AntragLimitProps {
  antraegeLeftToday: number;
  isLimited: boolean;
  limit: number;
}
